export const JSM_CMDB_DATA_MANAGER_CHANGE_BOARDING = 'jsm-cmdb-data-manager-changeboarding';
